// extracted by mini-css-extract-plugin
export default {"wrapper":"Supports_wrapper__ib2AP"};